export const tapyblAiHomeText = {
  title: 'Hello',
  subtitle: 'Welcome back!',
  selection: 'What would you like to create?',
  aiAssistants: 'AI assistants',
  videos: 'Videos',
  courses: 'Courses',
  coursesDescription:
    'Create impactful courses tailored to your goals to inspire learning and empower your audience',
  aiAssistantsDescription:
    'Generate AI assistants from your content, accessible to learners across your workspace or within specific courses',
  aiVideosDescription:
    'Transform your existing content into engaging videos and microlessons in minutes to jumpstart your learning mastery',
  microlessons: 'Microlessons',
  microlesosnsDescription:
    'Generate short, intuitive, microlessons outside of your courseware and instantly share with your learners',
  microreels: 'Microreels',
  microreelsDescription:
    'Generate a set of short, standalone microreels directly from a prompt and share them with your learners',
  homeTitle: 'Home',
  heroTitle: 'Create a microreel',
  heroSubtitle:
    "Drop a document or video here or describe what you need and we'll write it",
  newMicroreel: 'New microreel',
  studio: 'Studio',
  beta: 'Beta',
  newPost: 'New post',
  newFeedback: 'New feedback',
  groupReelsTitle: 'Group reels into a course',
  groupReelsSubtitle:
    'Sequence what you already made and send it to a group of learners.',
  newCourse: 'New course',
  browseCourses: 'Browse courses',
  pipelineTitle: 'Your content pipeline',
  documents: 'Documents',
  uploaded: 'uploaded',
  generated: 'generated',
  published: 'published',
  glanceTitle: 'Learning at a glance',
  completed: 'Completed',
  inProgress: 'In progress',
  notStarted: 'Not started',
  avgScore: 'Avg. score',
  learnersTotal: 'Learners total',
  reelsCount: (count: number) => `${count} ${count === 1 ? 'reel' : 'reels'}`,
  completionsCount: (count: number) =>
    `${count} ${count === 1 ? 'completion' : 'completions'}`,
  notStartedMeta: 'not started',
  chipNotStarted: 'Not started',
  chipInProgress: 'In progress',
  chipCompleted: 'Completed',
  noScoresNote:
    'No scores yet — they show up once learners finish their first course.',
  viewMore: 'View more',
};
